import React, { memo } from 'react';

import { LaneRowPropsBase } from '../types';

import { GradientNumericLaneRow } from './Gradients';
import { PointsNumericLaneRow } from './Points';
import { NumericLaneRowConfiguration, PointDataLaneRowDisplayType } from './configuration';

interface PointDataLaneRowProps extends LaneRowPropsBase<NumericLaneRowConfiguration> {
	id: string;
}

const NumericLaneRowInternal: React.FC<PointDataLaneRowProps> = (props) => {
	const rowId = `${props.id}--${props.configuration.displayConfiguration.type}`;
	switch (props.configuration.displayConfiguration.type) {
		case PointDataLaneRowDisplayType.Points:
			return (
				<PointsNumericLaneRow
					key={rowId}
					id={rowId}
					configuration={props.configuration}
					display={props.configuration.displayConfiguration}
					width={props.width}
					heightInPx={props.heightInPx}
					scale={props.scale}
					lane={props.lane}
					position={props.position}
				></PointsNumericLaneRow>
			);
		case PointDataLaneRowDisplayType.Gradients:
			return (
				<GradientNumericLaneRow
					key={rowId}
					id={rowId}
					configuration={props.configuration}
					display={props.configuration.displayConfiguration}
					width={props.width}
					heightInPx={props.heightInPx}
					scale={props.scale}
					lane={props.lane}
					position={props.position}
				></GradientNumericLaneRow>
			);
	}
};

export const NumericLaneRow = memo(NumericLaneRowInternal);
